
function Payslips() {
  return (<div >Payslips</div>);
}

export default Payslips;
